import React, { useEffect, useState } from "react";
import { Event } from "../pages/HomeTrainer";
import styles from "../pages//Home.module.scss";
import { db } from "../Firebase";
import { doc, onSnapshot } from "firebase/firestore";

interface EventItemProps {
	event: Event;
}

const StudentItems: React.FC<EventItemProps> = ({ event }) => {
	const [status, setStatus] = useState("");
	const [isEventInProgress, setIsEventInProgress] = useState("");

	useEffect(() => {
		const docRef = doc(db, "status", event.id); // ドキュメントIDを指定
		const unsubscribe = onSnapshot(docRef, (doc) => {
			if (doc.exists()) {
				const newStatus = doc.data().status;
				setStatus(newStatus);
			}
		});

		return () => {
			// コンポーネントがアンマウントされるときに監視を解除
			unsubscribe();
		};
	}, [event.id]);

	function formatDateTime(dateTimeString: string): string {
		const datetime = new Date(dateTimeString);
		const hours = datetime.getHours();
		const minutes = datetime.getMinutes();
		const formattedTime = `${hours}:${minutes.toString().padStart(2, "0")}`;
		return formattedTime;
	}

	interface SettingImgProps {
		summary: string;
	}

	const SettingImg: React.FC<SettingImgProps> = ({ summary }) => {
		let thumbImage;
		let subImage;
		switch (summary) {
			case "五十嵐渉":
				thumbImage = "images/igarashi.png";
				subImage = "images/igarashi02.png";
				break;
			case "高橋秀斗":
				thumbImage = "images/shuto.png";
				subImage = "images/shuto02.png";
				break;
			case "杉野舞":
				thumbImage = "images/sugimai.png";
				subImage = "images/sugimai02.png";
				break;
			case "寺越真知子":
				thumbImage = "images/machiko.png";
				subImage = "images/machiko02.png";
				break;
			case "大沢臣爾":
				thumbImage = "images/osawa01.png";
				subImage = "images/osawa02.png";
				break;
			case "鈴木美佳":
				thumbImage = "images/suzu.png";
				subImage = "images/suzu02.png";
				break;
			case "市村洋隆":
				thumbImage = "images/ichimura.png";
				subImage = "images/ichimura02.png";
				break;
			case "白戸智真":
				thumbImage = "images/shirato.png";
				subImage = "images/shirato03.png";
				break;
			case "齋藤りり子":
				thumbImage = "images/ririko.png";
				subImage = "images/ririko02.png";
				break;
			case "田中克幸":
				thumbImage = "images/tanaka.png";
				subImage = "images/tanaka02.png";
				break;
			case "田中克幸[リモ]":
				thumbImage = "images/tanaka.png";
				subImage = "images/tanaka02.png";
				break;
			case "関聖二":
				thumbImage = "images/seki.png";
				subImage = "images/seki02.png";
				break;
			default:
				thumbImage = "images/default.png";
				subImage = "images/default.png";
				break;
		}
		return (
			<>
				<img src={thumbImage} alt={event.summary} />
				<img src={subImage} alt={event.summary} />
			</>
		);
	};

	useEffect(() => {
		// イベントの開始と終了時間をDateオブジェクトに変換
		const startTime = new Date(event.start.dateTime);
		const endTime = new Date(event.end.dateTime);
		// ページ読み込み時にも現在時刻とイベントの開始・終了時間を比較
		const now = new Date();
		if (now < startTime) {
			setIsEventInProgress("yet");
		} else if (now > endTime) {
			setIsEventInProgress("done");
		} else {
			setIsEventInProgress("inProgress");
		}
		// 5分ごとに現在時刻とイベントの開始・終了時間を比較
		const timer = setInterval(() => {
			const now = new Date();
			if (now < startTime) {
				setIsEventInProgress("yet");
			} else if (now > endTime) {
				setIsEventInProgress("done");
			} else {
				setIsEventInProgress("inProgress");
			}
		}, 300000);
		return () => clearInterval(timer);
	}, [event.end.dateTime, event.start.dateTime]);

	const statusClass = getStatusClass(status);

	return (
		<>
			<div
				key={event.id}
				className={`${statusClass} ${
					isEventInProgress === "yet" && styles.yet
				} ${isEventInProgress === "done" && styles.done}`}
			>
				<figure className={styles.img}>
					<SettingImg summary={event.summary} />
				</figure>
				<p className={styles.name}>{event.summary}</p>
				<p className={styles.time}>
					{formatDateTime(event.start.dateTime)}-
					{formatDateTime(event.end.dateTime)}
				</p>
			</div>
		</>
	);
};

export default StudentItems;

function getStatusClass(status: string): string {
	switch (status) {
		case "leave":
			return styles.leave;
		case "rest":
			return styles.rest;
		case "support":
			return styles.support;
		case "mtg":
			return styles.mtg;
		case "remote":
			return styles.remote;
		case "leavework":
			return styles.leavework;
		default:
			return styles.default;
	}
}
